"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryStore = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const lincd_storage_1 = require("../ontologies/lincd-storage");
const QuadSet_1 = require("lincd/lib/collections/QuadSet");
const SHACL_1 = require("lincd/lib/shapes/SHACL");
const QuadArray_1 = require("lincd/lib/collections/QuadArray");
const LinkedStorage_1 = require("lincd/lib/utils/LinkedStorage");
let InMemoryStore = class InMemoryStore extends Shape_1.Shape {
    constructor(n) {
        super(n);
    }
    init() {
        // console.log('Init ' + this.toString());
        if (!this.initPromise) {
            this.initPromise = this.loadContents();
        }
        return this.initPromise;
    }
    loadContents() {
        //by default an in-memory store starts empty - it has no permanent storage
        //overwrite this method to change that
        this.contents = new QuadSet_1.QuadSet();
        return Promise.resolve(this.contents);
    }
    /**
     * returns the contents of the InMemoryStore as a QuadSet
     * do NOT modify the returned QuadSet directly. Add or remove contents to this store instead
     */
    getContents() {
        return this.contents;
    }
    update(toAdd, toRemove) {
        return this.init().then(() => {
            if (toAdd) {
                this._addMultiple(toAdd);
            }
            if (toRemove) {
                this._deleteMultiple(toRemove);
            }
            //this method should only get called if either toAdd or toRemove is not empty
            return this.onContentsUpdated();
        });
    }
    getDefaultGraph() {
        //NOTE: we changed this from a specific graph for each store BACK null, which means things will be stored in the default graph
        // because storing quads in multiple graphs easily becomes error-prone.
        // Removing a triple from one store might not remove it from the main graph.
        // for example, auth will store users serialised as JSONLD in sessions, these quads get added back to the main graph
        // until we have a better solution for this, we aim to only use the default graph as much as possible (which means no specific graph os used, thus return null)
        // return null;
        // return defaultGraph;
        return models_1.Graph.getOrCreate(this.namedNode.uri);
    }
    add(quad) {
        return this.init().then(() => {
            this.addNewContents(new QuadArray_1.QuadArray(quad));
            this.onContentsUpdated();
            return Promise.resolve(true);
        });
    }
    addMultiple(quads) {
        return this.init().then(() => {
            this._addMultiple(quads);
            this.onContentsUpdated();
            return Promise.resolve(true);
        });
    }
    delete(quad) {
        return this.init().then(() => {
            // this.contents.delete(quad);
            this._deleteMultiple(new QuadArray_1.QuadArray(quad));
            this.onContentsUpdated();
            return true;
        });
    }
    deleteMultiple(quads) {
        return this.init().then(() => {
            this._deleteMultiple(quads);
            this.onContentsUpdated();
            return true;
        });
    }
    clearProperties(subjectToPredicates) {
        return this.init().then(() => {
            let toDelete = new QuadSet_1.QuadSet();
            this.contents.forEach((q) => {
                if (subjectToPredicates.has(q.subject) &&
                    subjectToPredicates.get(q.subject).has(q.predicate)) {
                    toDelete.add(q);
                }
            });
            if (toDelete.size > 0) {
                return this.deleteMultiple(toDelete);
            }
            return false;
        });
    }
    setURIs(nodeToCurrentUriMap) {
        //by default an in-memory store does not support setting URIs,
        // if it's used in a local context for in memory storage it doesn't really care about permanent storage URI's
        // if it's used in a different context, this method should be overwritten
        return Promise.resolve([]);
    }
    removeNodes(nodes) {
        //when storage calls removeNodes, all quads have already been removed locally
        //and an in memory store always holds all data in memory,
        //so there is nothing to do here
        return Promise.resolve(true);
    }
    loadShape(shapeInstance, request) {
        return this.init().then(() => {
            return this.getRequestQuads(shapeInstance, request);
            //for testing: add timer
            // return new Promise((resolve, reject) => {
            //   setTimeout(() => {
            //get quads for each (nested) shape / property shape
            // let quads = this.getRequestQuads(shapeInstance, request);
            // return resolve(quads);
            // }, 1500);
            // });
        });
    }
    loadShapes(shapeInstances, request) {
        return this.init().then(() => {
            let quads = new QuadArray_1.QuadArray();
            shapeInstances.forEach((shapeInstance) => {
                this.getRequestQuads(shapeInstance, request, quads);
            });
            return quads;
            // return new Promise((resolve, reject) => {
            //   setTimeout(() => {
            //     //get quads for each (nested) shape / property shape
            //     //TODO: update getRequestQuads to work with shape set
            //     // possibly even merge definitions of loadShape and loadShapes? is it select? query?
            //     // let quads = this.getRequestQuads(shapeInstances, request);
            //     // return Promise.resolve(quads);
            //     // return resolve(quads);
            //     return resolve([] as any);
            //   }, 1500);
            // });
        });
    }
    onContentsUpdated() {
        //by default in memory store does nothing here. But extending classes could choose to sync to a more permanent form of storage
        return Promise.resolve(false);
    }
    addNewContents(quads) {
        //get the target graph for this store, if configured
        let graph = LinkedStorage_1.LinkedStorage.getGraphForStore(this) || this.targetGraph || models_1.defaultGraph;
        //if there is one, move the quads into that graph
        if (graph) {
            quads = quads.moveTo(graph, false);
        }
        this.contents.addFrom(quads);
        return quads;
    }
    _addMultiple(quads) {
        this.addNewContents(quads);
        // this.contents = this.contents.concat(quads);
    }
    _deleteMultiple(quads) {
        //first we add the quads to the right graph (which effectively ADDS these quads to this store)
        //then we remove them from the contents
        //get the target graph for this store, if configured
        let graph = LinkedStorage_1.LinkedStorage.getGraphForStore(this) || this.targetGraph || models_1.defaultGraph;
        //if there is one, move the quads into that graph
        if (graph) {
            quads = quads.moveTo(graph, false);
        }
        quads.forEach((quad) => {
            this.contents.delete(quad);
            quad.remove(false);
        });
    }
    getRequestQuads(source, request, quads = new QuadArray_1.QuadArray()) {
        // let {shape, properties}: {shape: typeof Shape; properties?: (PropertyShape | BoundPropertyShapes)[]} = request;
        request.forEach((propertyRequest) => {
            let subRequest;
            let propertyShape;
            let propertyShapeSource;
            //if an entry is an array, then it consists of the property shape + a sub request
            if (Array.isArray(propertyRequest)) {
                [propertyShape, subRequest] = propertyRequest;
            }
            else if (propertyRequest instanceof SHACL_1.PropertyShape) {
                propertyShape = propertyRequest;
            }
            if (propertyShape) {
                if (source instanceof QuadSet_1.QuadSet) {
                    propertyShapeSource = source
                        .getObjects()
                        .getQuads(propertyShape.path);
                }
                else if (source instanceof Shape_1.Shape) {
                    propertyShapeSource = source.getQuads(propertyShape.path);
                }
                propertyShapeSource.forEach((q) => quads.push(q));
            }
            if (subRequest) {
                this.getRequestQuads(propertyShapeSource, subRequest, quads);
            }
        });
        return quads;
    }
};
exports.InMemoryStore = InMemoryStore;
InMemoryStore.targetClass = lincd_storage_1.lincdStorage.InMemoryStore;
exports.InMemoryStore = InMemoryStore = __decorate([
    package_1.linkedShape
], InMemoryStore);
//# sourceMappingURL=InMemoryStore.js.map